import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { AccessAwareError } from "~/components/reusable/errors/AccessAwareError"
import { Module } from "~/components/design-system/pages"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import {
  SETTINGS_PATH,
  findSettingsNavItem,
  useSettingsNavSections,
} from "~/components/sidebar/settingsNav"
import { useCompany } from "~/hooks/useCompany"
import { usePageTracking } from "~/hooks/usePageTracking"
import { adminRouteGuard } from "~/utils/routeGuards"

export const Route = createFileRoute("/_auth/settings/_layout")({
  staticData: { skipSkuStoreData: true },
  beforeLoad: adminRouteGuard,
  component: RouteComponent,
  errorComponent: AccessAwareError,
})

function RouteComponent() {
  usePageTracking("Settings")
  const { pathname } = useLocation()
  const sections = useSettingsNavSections()
  const activeItem = findSettingsNavItem(sections, pathname)

  const { isLoading } = useCompany()

  if (isLoading) {
    return <LoadingOverlay />
  }

  const breadcrumbs = activeItem
    ? [{ label: "Settings", href: SETTINGS_PATH }, { label: activeItem.name }]
    : undefined

  return (
    <Module breadcrumb={<BreadcrumbWrapper items={breadcrumbs} />}>
      <Outlet />
    </Module>
  )
}
